module.exports = __webpack_public_path__ + "static/img/PK@3x.f10927a3.jpg";